import styled from "styled-components";

export const DateInput = styled.input.attrs({})`
  width: 100%;
  border: 1px solid #ece6ee;
  color: gray;
  height: 40px;
  border-radius: 4px;
  padding-left: 5px;
  position: relative;
  &::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    width: auto;
    height: auto;
  }
`;

export const TextDateInput = styled.input.attrs({})`
  width: 100%;
  border: 1px solid #ece6ee;
  color: gray;
  height: 40px;
  border-radius: 4px;
  padding-left: 5px;
`;

export const TimeInput = styled.input.attrs({})`
  border: 1px solid red;
  &::-webkit-calendar-picker-indicator {
    background: none;
    display: none;
  }
`;
